import { render } from "./App.vue?vue&type=template&id=ef04f0d6&lang=pug"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ef04f0d6&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__